import React, { useEffect, useRef } from "react";
import { Button } from "@mui/material";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ReportExcel({ data, columns, setData }) {
	const ref = useRef(null);

	useEffect(() => {
		ref.current.click();
		setData(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ExcelFile
			element={
				<Button ref={ref} style={{ display: "none" }}>
					دانلود
				</Button>
			}
			filename="report">
			{data &&
				Object.keys(data).map((item, index) => {
					return (
						<ExcelSheet key={index} name={item.toString()} data={data[item]}>
							{columns[item].map((d, index) => {
								return <ExcelColumn key={d} label={d.toString()} value={d} />;
							})}
						</ExcelSheet>
					);
				})}
		</ExcelFile>
	);
}
